import React from 'react';
import CardHeader from '@material-ui/core/CardHeader';
import { makeStyles } from '@material-ui/core/styles';
import { useCardStyles } from '../../App';
import theme from '../../theme';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import ChatIcon from '@material-ui/icons/Chat';
import { useHistory } from 'react-router';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
// import Slide from "@material-ui/core/Slide";
import SubmitButton from '../Button/SubmitButton';
import CancelButton from '../Button/CancelButton';
import ButtonWrapper from '../Button/ButtonWrapper';
// import Typography from "@material-ui/core/Typography";
import { ButtonProps, DialogProps } from '../../@types';
import ChatRoom from '../../components/ChatRoom/ChatRoom';
import { ArrowForwardIos, MoreVert } from '@material-ui/icons';

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props}></Slide>;
// });

const useStyles = makeStyles(() => ({
	buttonContainer: {
		width: '80%',
		margin: '20px auto 0px',
		padding: '5px 0px 15px',
		display: 'grid',
		gridTemplateColumns: '1fr 1fr 1fr',
		gridTemplateRows: '1fr',
		gap: '0px 0px',
		gridTemplateAreas: '. . .',
	},
	title: {
		color: theme.palette.common.black,
		fontWeight: 500,
		marginLeft: '5px',
	},
	avatar: {
		backgroundColor: theme.palette.secondary.main,
		marginLeft: '10px',
	},
	action: {
		padding: '20px 1vw 0px 0px',
	},
}));

export type ItemCardHeaderProps = {
	item: {
		name: string;
	};
};

export const ItemCardHeader = (props: ItemCardHeaderProps) => {
	const classes = useStyles();
	const history = useHistory();

	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleSubmit = () => {
		setOpen(false);
		//   props.onSubmit();
	};

	const cancelButtonProps: ButtonProps = {
		onClick: handleClose,
	};

	const submitButtonProps: ButtonProps = {
		onClick: handleSubmit,
	};

	const handleChat = () => {
		history.push('/chat');
	};

	return (
		<>
			<CardHeader
				classes={{
					title: classes.title,
					action: classes.action,
				}}
				// avatar={
				// 	<Avatar
				// 		aria-label={`${props.item.name}`}
				// 		className={classes.avatar}
				// 	>
				// 		{props.item.name[0]}
				// 	</Avatar>
				// }
				title={
					<>
						<Typography variant='h6' className={classes.title}>
							{props.item.name}
						</Typography>
					</>
				}
				action={
					<IconButton onClick={handleClickOpen} aria-label='chat'>
						<ArrowForwardIos />
					</IconButton>
				}
			/>
			<Box>
				<Dialog
					open={open}
					// TransitionComponent={Transition}
					keepMounted
					onClose={handleClose}
					aria-labelledby='alert-dialog-slide-title'
					aria-describedby='alert-dialog-slide-description'
				>
					<ChatRoom />
				</Dialog>
			</Box>
		</>
	);
};
